<script>
import { computed, getCurrentInstance, ref, provide } from 'vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import { INJECT_KEY_OPENING_COMPLETE } from '@rebuild/materials/shared/page_container/useDisplayLogic';

export default {
	name: 'SurfLayoutWrapperMob',
	components: {
		SmartLayoutC
	},
	setup() {
		const vm = getCurrentInstance();
		const displaySources = ['page', 'subModule', 'module'];
		const showNavbar = computed(() => displaySources.includes(vm.proxy.$route.meta?.source));

		const openingComplete = ref(true); // 同步流程，避免注入报错
		provide(INJECT_KEY_OPENING_COMPLETE, openingComplete);

		return {
			showNavbar
		};
	},
	render() {
		const Navigation = <SmartLayoutC compId="layout_nav" mode="mob-basic" key="layout_nav" />;
		// 默认缓存
		// 如需强刷页面，配合 query 手动更新
		const AlivePageContainer = (
			<keep-alive>
				<router-view key={this.$route.fullPath} />
			</keep-alive>
		);

		let layouts = [];
		const initRender = () => {
			if (this.showNavbar) {
				layouts = [Navigation, AlivePageContainer];
			} else {
				layouts = [AlivePageContainer];
			}
		};
		initRender();

		return <div class="surf-layout mob-surf-layout">{...layouts}</div>;
	}
};
</script>

<style lang="less" scoped>
.surf-layout {
	background: var(--theme-color);
}
</style>
